import { of } from 'rxjs';
import { ignoreElements } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { computeDeleteActionTypes, computeDeleteLoadingAction, computeDeleteLoadedAction, } from '../ducks/ComputeDelete.ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import ComputeResource from '../../../Compute.resource';
const loadComputeDeleteArgs = {
    filterOnType: computeDeleteActionTypes.LOAD,
    loadResource: (payload, state) => {
        return ComputeResource.deleteCompute(payload.workspaceId, payload.id);
    },
    loadingAction: computeDeleteLoadingAction,
    loadedAction: (successData, payload, error) => {
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData,
            error: error,
        };
        return of(computeDeleteLoadedAction(payload, result));
    },
};
export const afterDeleteCompute = (action$) => {
    return action$.pipe(ofType(computeDeleteActionTypes.LOADED), ignoreElements());
};
export const loadComputeEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadComputeDeleteArgs);
export default combineEpics(loadComputeEpic, afterDeleteCompute);

//# sourceMappingURL=ComputeDeleteEpic.js.map
